import React from 'react';
import { useIntl } from 'react-intl';

import { Filter } from '~/evifields/src/types/Filter';
import { EnumValue } from '~/evifields/src/types/Value';

import { getFilterValuesLength } from '../../../../evifields/src/utils/getFilterValuesLength';
import { TextContainer } from '../TextContainer';
import { Field } from '../types';
import { EnumValuesPreview } from './EnumValuesPreview';

interface Props {
  field: Field<'enum_set'>;
  filter: Filter<EnumValue>;
}

export const EnumSetValuesPreview = ({ field, filter }: Props) => {
  const intl = useIntl();
  const filterValuesLength = getFilterValuesLength(filter);
  const { selectAllLabel } = filter.asyncValue ?? {};

  return filterValuesLength > 1 ? (
    <TextContainer
      text={intl.formatMessage(
        {
          id: 'EnumSetValuesPreview.valuesCount',
          defaultMessage: '{count} values',
          description:
            'Display count of selected enum values. Example: count = "5"',
        },
        {
          count: selectAllLabel ?? filterValuesLength,
        },
      )}
    />
  ) : (
    <EnumValuesPreview field={field} filter={filter} />
  );
};
